import { useEffect, useRef } from "react";

export function useContentSize({
  contentGutter,
  minViewportWidth,
  maxContentWidth,
  minCharsPerLine, // Unused until we build support for dynamic font sizes
  maxCharsPerLine,
}) {
  const { width } = useViewportSize();
  const minContentWidth = minViewportWidth - contentGutter;
  const contentWidth = Math.max(Math.min(width - contentGutter, maxContentWidth), minViewportWidth);

  // Estimate the number of characters per line
  const charScale = maxCharsPerLine / maxContentWidth;
  let charsPerLine = Math.round(contentWidth * charScale);

  // Line wraps reduce the characters per line, and the narrower the screen
  // the more breaks occur. Estimate this.
  const estimatedLostCharactersPerWrap = 5;
  charsPerLine = Math.round(charsPerLine - 5 * (maxContentWidth / contentWidth));

  // To estimate the number of lines per paragraph:
  //   Math.ceil(content.length / charsPerLine)

  // To estimate the height of an image/video with a known aspect ratio:
  //   Math.round(contentWidth / aspectRatio)

  return {
    contentWidth,
    charsPerLine,
  };
}

function useViewportSize({ ssr = false, width = 0, height = 0 } = {}) {
  const isClient = typeof window === "object";
  const sizeRef = useRef(
    ssr || !isClient
      ? { width, height }
      : {
          width: window.innerWidth,
          height: window.innerHeight,
        },
  );

  useEffect(() => {
    const handleResize = () => {
      sizeRef.current = {
        width: window.innerWidth,
        height: window.innerHeight,
      };
    };

    if (sizeRef.current.width === 0 || sizeRef.current.height === 0) handleResize();

    window.addEventListener("resize", handleResize, { passive: true });
    return () => window.removeEventListener("resize", handleResize, { passive: true });
  }, []);

  return sizeRef.current;
}

export default useContentSize;
